import React, { useState } from "react";
import { Tooltip, IconButton, Icon } from "@material-ui/core";
import { permissionName } from "utils/constants";
import { useRedirect } from "react-admin";
import DialogSelectOption from "./DialogSelectOptionReport";

const CustomToolbar = ({ basePath, id, dataTable, permissions, printReport }) => {
  const permission = permissions.find((i) => i.Name === permissionName["GL.FinancialReport"]);
  const redirect = useRedirect();
  const [openDialog, setOpenDialog] = useState(false);

  const CloseDialog = (type) => {
    setOpenDialog(false);
    if (type) {
      printReport(type?.value);
    }
  };

  return (
    <React.Fragment>
      <Tooltip title={"Settings"}>
        <IconButton
          aria-label="setting"
          disabled={permission["Update"] === false}
          onClick={() => redirect(`financialReport/${id}/show`)}
        >
          <Icon className="material-icons-outlined" fontSize={"medium"}>
            settings
          </Icon>
        </IconButton>
      </Tooltip>
      {dataTable.length > 0 && (
        <Tooltip title={"Print"}>
          <IconButton aria-label="Print" onClick={() => setOpenDialog(true)}>
            <Icon className="material-icons-outlined" fontSize={"medium"}>
              print
            </Icon>
          </IconButton>
        </Tooltip>
      )}
      {openDialog && <DialogSelectOption open={openDialog} onClose={CloseDialog} />}
    </React.Fragment>
  );
};

export default CustomToolbar;
